import { useState, useEffect } from 'react';

export const useFilters = (allDishes, categories) => {
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredDishes, setFilteredDishes] = useState([]);
    const [dishes, setDishes] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("ALL");
    const [parentId, setParentId] = useState(null);

    useEffect(() => {
        if (!Array.isArray(allDishes)) return;

        let filtered = [...allDishes];

        // STEP 1: CATEGORY FILTER
        if (selectedCategory && selectedCategory !== "ALL") {
            filtered = filtered.filter(
                item => Number(item.parentId) === Number(selectedCategory)
            );
        }

        // STEP 2: SEARCH FILTER
        const searchValue = searchTerm?.toLowerCase().trim() || "";
        if (searchValue) {
            filtered = filtered.filter(
                item =>
                    item?.dishName &&
                    item.dishName.toLowerCase().includes(searchValue)
            );
        }

        // STEP 3: VEG / NON-VEG FILTER
        if (isVegSelected) {
            filtered = filtered.filter(item => item?.tag === "Veg");
        } else if (isNonVegSelected) {
            filtered = filtered.filter(item => item?.tag === "Non_Veg");
        }

        // STEP 4: STATUS FILTER
        filtered = filtered.filter(item => item?.menuStatus === "Enable");

        setFilteredDishes(filtered);
        setDishes(filtered);
    }, [selectedCategory, searchTerm, isVegSelected, isNonVegSelected, allDishes, categories]);

    const clearFilters = () => {
        setSearchTerm("");
        setIsVegSelected(false);
        setIsNonVegSelected(false);
        setSelectedCategory("ALL");
        setParentId(null);
    };

    const handleCategoryClick = (cat) => {
        setSelectedCategory(cat.categoryName);
        setParentId(cat.categoryName === "ALL" ? null : cat.dishId);
        setIsVegSelected(false);
        setIsNonVegSelected(false);
    };

    return {
        isVegSelected,
        setIsVegSelected,
        isNonVegSelected,
        setIsNonVegSelected,
        searchTerm,
        setSearchTerm,
        filteredDishes,
        dishes,
        selectedCategory,
        setSelectedCategory,
        parentId,
        clearFilters,
        handleCategoryClick
    };
};